import { TranslateService } from '@ngx-translate/core';
import type { AppLanguage } from '../../Services/language.service';

/** Translation families of backend codes (order states, product condition). */
export type CodeFamily = 'shared.states' | 'shared.productCondition';

/**
 * Label of a backend code, e.g. `translateCode(translate, 'shared.states', 'DELIVERED')`.
 * Unknown codes return `fallback(code)` (the code itself by default).
 * `language` reads a given language instead of the current one (it must be loaded; French always is,
 * as the default language).
 */
export function translateCode(
  translate: TranslateService,
  family: CodeFamily,
  code: string | null | undefined,
  fallback: (code: string) => string = (c) => c,
  language?: AppLanguage,
): string {
  if (!code) {
    return '';
  }
  const key = `${family}.${code}`;
  const label: string = language
    ? translate.getParsedResult(translate.translations[language] ?? {}, key)
    : translate.instant(key);
  return label && label !== key ? label : fallback(code);
}

/** "DELIVERY_BILL" → "Delivery bill": readable fallback for codes without a translation. */
export function humanizeCode(code: string): string {
  return code
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, (c) => c.toUpperCase());
}
